import React from 'react';
import PriceDisplay from './PriceDisplay';
const ProductPrice = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!props.price) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(PriceDisplay, { inline: props.inline, type: props.price.type, max: (_b = (_a = props.price.max) === null || _a === void 0 ? void 0 : _a.sales) === null || _b === void 0 ? void 0 : _b.formatted, min: (_d = (_c = props.price.min) === null || _c === void 0 ? void 0 : _c.sales) === null || _d === void 0 ? void 0 : _d.formatted, minFullPrice: (_f = (_e = props.price.min) === null || _e === void 0 ? void 0 : _e.list) === null || _f === void 0 ? void 0 : _f.formatted, list: (_g = props.price.list) === null || _g === void 0 ? void 0 : _g.formatted, sales: (_h = props.price.sales) === null || _h === void 0 ? void 0 : _h.formatted, isExchangePrice: props.isExchangePrice, promotions: props.promotions, isPlp: props.isPlp })));
};
ProductPrice.defaultProps = {
    inline: false,
};
export default ProductPrice;
